"use client";

import { FC } from "react";
import { uniqueId } from "lodash";

import ProjectItem from "@/components/project-item/ProjectItem";
import useStateData from "@/hooks/useStateData";
import { ProjectType } from "@/lib/types";

interface ProjectListProps {
  projects: ProjectType[];
}

const ProjectList: FC<ProjectListProps> = ({ projects }) => {
  const { selectedFilter, searchFilter } = useStateData();

  const categoryProjects: ProjectType[] = selectedFilter
    ? projects.filter((project) => project?.tags.includes(selectedFilter))
    : projects;

  const filteredProjects: ProjectType[] = searchFilter
    ? categoryProjects.filter((project) =>
        project?.title.toLowerCase().includes(searchFilter.toLowerCase())
      )
    : categoryProjects;
  return (
    <>
      {filteredProjects.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10">
          {filteredProjects.map((item) => (
            <ProjectItem key={uniqueId("project")} {...item} />
          ))}
        </div>
      ) : (
        <div className="mt-24 text-center">No Projects Found</div>
      )}
    </>
  );
};

export default ProjectList;
